import React, { useMemo, useState } from 'react';

import { useForm } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  CreateLocalizationKeyFormState,
  CreateLocalizationKeyFormContext,
  createLocalizationKeySchemaDefault,
  createLocalizationKeyFormStateDefault,
} from '@Forms/localizations/CreateLocalizationKeyFormContext';

export const CreateLocalizationKeyFormProvider: React.FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<CreateLocalizationKeyFormState>>>(
    createLocalizationKeySchemaDefault
  );
  const methods = useForm({
    defaultValues: createLocalizationKeyFormStateDefault,
    resolver: yupResolver(schema),
  });
  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return (
    <CreateLocalizationKeyFormContext.Provider value={value}>
      {children}
    </CreateLocalizationKeyFormContext.Provider>
  );
};
